export default __webpack_public_path__ + "8450d0e.png";